var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"drawVideo",staticClass:"overlay-canvas-draw",on:{"mousemove":_vm.onMouseMove,"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}})])
}
var staticRenderFns = []

export { render, staticRenderFns }